module.exports = __webpack_public_path__ + "static/blog-1-88eb85bb637aeb4db6d5d35f2b77f3a3.jpg";